<template>
  <div class="tabs-container">
    <v-btn
      class="tab-link"
      v-for="item in items"
      :key="item.value"
      :to="item.to"
      :class="{ active: isActive(item) }"
    >
      <v-icon>{{ item.icon }}</v-icon>
      {{ item.title }}
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ConsoleMenu",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentRaceName: "race/getCurrentRaceName",
      getCurrentRaceId: "race/getCurrentRaceId",
    }),
    items() {
      return [
        {
          icon: "$vuetify.icons.race",
          title: this.currentRaceName || "Current-race",
          to: { name: "race", params: { raceId: this.$route.params.raceId } },
          value: "race",
        },
        {
          icon: "$vuetify.icons.floppy",
          title: "Favorites",
          to: {
            name: "favorites",
            params: { raceId: this.$route.params.raceId },
          },
          value: "favorites",
        },
        {
          icon: "$vuetify.icons.comparison",
          title: "Comparison",
          to: {
            name: "compare",
            params: { compareId: this.$route.params.compareId },
          },
          value: "comparison",
        },
      ];
    },
  },
  methods: {
    select(index) {
      this.$router.push(this.items[index].to);
    },
    isActive(item) {
      return this.$route.name === item.to.name;
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-container {
  align-self: flex-end;
}

.tab-link {
  height: 32px !important;
  background: white !important;
  color: var(--v-blue-darken-1);
  box-shadow: none;
  border: 1px solid var(--v-blue-lighten-2);
  border-radius: 6px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom: none;
  text-transform: capitalize;

  &:not(:first-child) {
    margin-left: -3px;
  }

  $elements: 3;
  @for $i from 0 to $elements {
    &:nth-child(#{$i + 1}) {
      z-index: #{$elements - $i};
    }
  }
}

::v-deep {
  .theme--light.v-btn--active::before {
    background: var(--v-blue-lighten-4);
    opacity: 1;
  }

  .v-btn--active {
    margin-bottom: -2px;
  }

  .v-btn__content {
    align-items: flex-start;

    svg {
      height: 16px;
      margin-right: 4px;
    }
  }
  .theme--light:not(.active)::before {
    background: initial;
  }
}
</style>
